/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "ie": {
                "nested": {
                  "model": {
                    "nested": {
                      "Business": {
                        "fields": {
                          "businessName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "businessAddressToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "vatNumber": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "vatName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "vatAddress": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "vatCountryCode": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "websiteUrl": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "businessRegistrationNumber": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "countryOfRegistration": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "tradingName": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "tradingAddressToken": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "corporateTaxId": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "personalPublicServiceNumber": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          }
                        }
                      },
                      "Persona": {
                        "fields": {}
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.ie?.nested?.model?.nested?.Business && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.ie?.nested?.model?.nested?.Persona) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Business @ squareup/onboard/activation/ie/model.proto at 11:1
 */
export const Business = $root.lookupType('squareup.onboard.activation.ie.model.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * SOURCE Persona @ squareup/onboard/activation/ie/model.proto at 69:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.ie.model.Persona');
fixType(Persona);
Builder.createAndAttachToType(Persona);